// LeadTable component - displays all leads in a sortable table
// Shows on Lead Management page

/**
 * 
 * NOTES-SUMMARY-LEAD TABLE
 * 
 * What this component does:
 *  - Displays all leads in a table
 *  - Allows sorting by clicking column headers
 *  - Passes each lead to LeadRow component
 *  - Shows arrow indicating sort direction
 * 
 */




import React, { useState } from 'react';
import LeadRow from './LeadRow';
//import { getScoreColor } from '../../utils/constants';
import '../../styles/components.css';

function LeadTable({ leads, onLeadClick, selectedLeads, onLeadSelect, onSelectAll }) {
  // State for sorting
  const [sortField, setSortField] = useState('score');
  const [sortDirection, setSortDirection] = useState('desc');
  
  // Handle column header click (sort)
  const handleSort = (field) => {
    // If clicking same field, toggle direction
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // New field, default to descending
      setSortField(field);
      setSortDirection('desc');
    }
  };
  
  // Sort leads based on current sort field and direction
  const sortedLeads = [...leads].sort((a, b) => {
    let aVal = a[sortField];
    let bVal = b[sortField];
    
    // Handle null/undefined values
    if (aVal === null || aVal === undefined) aVal = '';
    if (bVal === null || bVal === undefined) bVal = '';
    
    // Compare values
    if (sortDirection === 'asc') {
      return aVal > bVal ? 1 : -1;
    } else {
      return aVal < bVal ? 1 : -1;
    }
  });

  // Calculate select all checkbox state
  const visibleLeadIds = sortedLeads.map(lead => lead._id);
  const selectedVisibleCount = visibleLeadIds.filter(id => selectedLeads.includes(id)).length;
  const isAllSelected = visibleLeadIds.length > 0 && selectedVisibleCount === visibleLeadIds.length;
  const isIndeterminate = selectedVisibleCount > 0 && selectedVisibleCount < visibleLeadIds.length;
  
  return (
    <div className="lead-table-container">
      <table className="lead-table">
        <thead>
          <tr>
            <th style={{ width: '50px', textAlign: 'center' }}>
              <input
                type="checkbox"
                checked={isAllSelected}
                ref={(el) => {
                  if (el) {
                    el.indeterminate = isIndeterminate;
                  }
                }}
                onChange={() => onSelectAll(visibleLeadIds)}
                style={{ cursor: 'pointer' }}
              />
            </th>
            <th onClick={() => handleSort('score')} className="sortable">
              Score {sortField === 'score' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('name')} className="sortable">
              Name {sortField === 'name' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('email')} className="sortable">
              Email {sortField === 'email' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('company')} className="sortable">
              Company {sortField === 'company' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('job_title')} className="sortable">
              Job Title {sortField === 'job_title' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('stage')} className="sortable">
              Stage {sortField === 'stage' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('interest_status')} className="sortable">
              Interest {sortField === 'interest_status' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th>Activity</th>
            <th>Notes</th>
            <th onClick={() => handleSort('assigned_to')} className="sortable">
              Assigned To {sortField === 'assigned_to' && (sortDirection === 'asc' ? '↑' : '↓')}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedLeads.map(lead => (
            <LeadRow 
              key={lead._id} 
              lead={lead} 
              onLeadClick={onLeadClick}
              isSelected={selectedLeads.includes(lead._id)}
              onSelect={onLeadSelect}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LeadTable;